export const SITE = {
  name: "Ayam Goreng Bandung Bu Iyin",
  shortName: "Bu Iyin",
  domain: "https://ayamgorengbuiyin.com",
  tagline: "Ayam Goreng Basah Khas Bandung",
  instagram: "https://www.instagram.com/agb.buiyin/",
  instagramHandle: "@agb.buiyin",
  grabfood:
    "https://food.grab.com/id/id/restaurant/ayam-goreng-bandung-bu-iyin-wijaya-melawai-delivery/6-C7UWSAXWT3WDRN",
};

export const NAV = [
  { label: "Beranda", href: "/", testid: "nav-link-beranda" },
  { label: "Menu", href: "/menu/", testid: "nav-link-menu" },
  { label: "Tentang", href: "/tentang/", testid: "nav-link-tentang" },
  { label: "Lokasi", href: "/lokasi/", testid: "nav-link-lokasi" },
  { label: "FAQ", href: "/faq/", testid: "nav-link-faq" },
];

export const LOCATIONS = [
  {
    id: "melawai",
    name: "Melawai — Jakarta Selatan",
    badge: "Outlet Open Space",
    address:
      "Jl. Wijaya II No. 76, Melawai, Kebayoran Baru, Jakarta Selatan",
    hours: [{ days: "Senin – Minggu", time: "09.00 – 22.00 WIB" }],
    note: "Area open space yang santai, bersebelahan dengan coffee shop mungil dan barbershop. Antrean memakai sistem digital — cukup pindai kode QR untuk memantau posisi antreanmu.",
    facilities: ["Parkir", "Mushola", "Toilet", "Tunai & Non-tunai"],
    maps: "https://www.google.com/maps/search/?api=1&query=Ayam+Goreng+Bu+Iyin+Jl+Wijaya+II+No+76+Melawai+Jakarta+Selatan",
    grabfood: true,
  },
  {
    id: "bintaro",
    name: "Fresh Market Emerald Bintaro",
    badge: "Kios Pertama",
    address: "Area kuliner Fresh Market Emerald Bintaro, Tangerang Selatan",
    hours: [
      { days: "Sabtu – Kamis", time: "09.00 – 22.00 WIB (last order 21.00)" },
      {
        days: "Jumat",
        time: "09.00 – 11.00 & 13.00 – 22.00 WIB (istirahat 11.00 – 13.00)",
      },
    ],
    note: "Kios sederhana tempat Bu Iyin pertama kali dikenal — antreannya nyaris tak pernah sepi sejak awal buka.",
    facilities: ["Area food court", "Takeaway"],
    maps: "https://www.google.com/maps/search/?api=1&query=Ayam+Goreng+Bu+Iyin+Fresh+Market+Emerald+Bintaro",
    grabfood: false,
  },
];

export const HOURS_NOTE =
  "Jam operasional dapat berubah sewaktu-waktu. Cek pengumuman terbaru di Instagram @agb.buiyin sebelum berkunjung.";

export const MENU = [
  {
    category: "Menu Utama",
    note: "Setiap paket disajikan dengan nasi hangat, jukut goreng, lalapan, dan dua sambal khas.",
    items: [
      {
        name: "Paket Ayam Goreng Basah",
        desc: "Ayam pejantan pilihan (dada/paha) yang diungkep bumbu kuning sampai meresap, digoreng sebentar agar tetap juicy. Lengkap dengan nasi hangat, jukut goreng, lalapan, sambal goang & sambal bawang.",
        price: "Rp35.000",
        tag: "Paling Diburu",
      },
      {
        name: "Ayam Goreng 1/2 Ekor",
        desc: "Setengah ekor ayam pejantan utuh dengan bumbu yang sama meresapnya — buat yang porsinya mau lebih puas.",
        price: "Rp65.000",
        tag: "Porsi Puas",
      },
    ],
  },
  {
    category: "Pelengkap",
    note: "Tambahan pendamping ayam gorengmu.",
    items: [
      {
        name: "Tahu Susu Lembang (isi 5)",
        desc: "Tahu susu goreng khas Lembang yang super lembut di dalam. Enak jadi lauk tambahan atau camilan.",
        price: "Rp20.000",
        tag: "Khas Bandung",
      },
      {
        name: "Ekstra Tahu / Tempe / Kerupuk",
        desc: "Pilihan pelengkap tambahan yang tersedia di outlet — tanyakan ke tim kami saat memesan.",
        price: null,
      },
    ],
  },
  {
    category: "Sambal Khas",
    note: "Sudah termasuk dalam setiap paket ayam.",
    items: [
      {
        name: "Sambal Goang",
        desc: "Sambal hijau segar dengan aroma kencur yang khas — pendamping klasik ayam goreng basah Bandung.",
        price: null,
        tag: "Segar",
      },
      {
        name: "Sambal Bawang",
        desc: "Sambal bawang gurih dengan pedas yang lebih nendang.",
        price: null,
        tag: "Nendang",
      },
    ],
  },
];

export const PRICE_NOTE =
  "Harga di atas terpantau dari liputan media dan dapat berubah sewaktu-waktu. Untuk harga dan ketersediaan terbaru, cek Instagram @agb.buiyin atau langsung di GrabFood.";

export const FAQS = [
  {
    q: "Apa itu ayam goreng basah?",
    a: "Ayam goreng basah adalah ayam goreng khas Bandung. Ayam diungkep (direbus) dalam bumbu kuning sampai bumbunya meresap, lalu digoreng sebentar saja — jadi teksturnya tetap juicy dan 'basah' bumbu, bukan kering renyah seperti ayam goreng pada umumnya.",
  },
  {
    q: "Apa bedanya dengan ayam goreng biasa?",
    a: "Perbedaannya di proses dan hasil akhir: bumbu ungkep kuningnya meresap sampai ke serat daging, dan karena digoreng sebentar, dagingnya tetap empuk berbumbu. Sajian ini juga khas karena didampingi jukut goreng.",
  },
  {
    q: "Apa itu jukut goreng?",
    a: "Dalam bahasa Sunda, 'jukut' berarti sayuran. Jukut goreng adalah sayuran hijau yang digoreng hingga gurih dan renyah — pendamping wajib ayam goreng basah khas Bandung.",
  },
  {
    q: "Sambal apa saja yang tersedia?",
    a: "Ada dua sambal khas: sambal goang, sambal hijau segar dengan aroma kencur; dan sambal bawang yang gurih dengan pedas lebih nendang. Keduanya sudah termasuk dalam setiap paket ayam.",
  },
  {
    q: "Di mana saja lokasi Ayam Goreng Bu Iyin?",
    a: "Ada dua outlet: Jl. Wijaya II No. 76, Melawai, Kebayoran Baru, Jakarta Selatan; dan kios di area kuliner Fresh Market Emerald Bintaro, Tangerang Selatan. Detail alamat dan petunjuk arah ada di halaman Lokasi.",
  },
  {
    q: "Jam bukanya kapan?",
    a: "Outlet Melawai buka setiap hari pukul 09.00 – 22.00 WIB. Outlet Bintaro buka pukul 09.00 – 22.00 WIB (last order 21.00), dengan jeda istirahat hari Jumat pukul 11.00 – 13.00 WIB. Jam dapat berubah — cek Instagram @agb.buiyin untuk info terbaru.",
  },
  {
    q: "Apakah bisa pesan antar?",
    a: "Bisa. Ayam Goreng Bu Iyin tersedia di GrabFood untuk area sekitar outlet Wijaya, Melawai. Kamu juga bisa datang langsung dan memesan untuk dibawa pulang (takeaway).",
  },
  {
    q: "Bagaimana sistem antreannya?",
    a: "Di outlet Melawai antrean memakai sistem digital — pindai kode QR di lokasi untuk mengambil nomor dan memantau posisi antrean. Di kedua outlet, antrean cenderung panjang saat jam makan siang dan malam, jadi datang lebih awal sangat disarankan.",
  },
  {
    q: "Berapa kisaran harganya?",
    a: "Paket ayam goreng basah mulai sekitar Rp35.000, ayam 1/2 ekor Rp65.000, dan tahu susu Lembang Rp20.000. Harga dapat berubah sewaktu-waktu — cek kanal resmi untuk harga terbaru.",
  },
  {
    q: "Bagaimana cara menghubungi Bu Iyin?",
    a: "Cara tercepat adalah lewat pesan langsung (DM) di Instagram @agb.buiyin. Untuk pesanan, gunakan GrabFood atau datang langsung ke outlet.",
  },
];

export const MARQUEE_ITEMS = [
  "Bumbu Ungkep Kuning",
  "Jukut Goreng Gurih",
  "Sambal Goang Kencur",
  "Sambal Bawang Nendang",
  "Ayam Pejantan Juicy",
  "Tahu Susu Lembang",
];
